import type { ClientSharePointWebLinkEmbed, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('clientSharePointWebLinkEmbeds');
export const findByIdThrows = createFindByIdThrows('clientSharePointWebLinkEmbeds');

type GetFulfilledClientSharePointWebLinkEmbeds = (state: YammerState) => Record<string, ClientSharePointWebLinkEmbed>;
export const getFulfilledClientSharePointWebLinkEmbeds: GetFulfilledClientSharePointWebLinkEmbeds = (state) =>
  state.clientSharePointWebLinkEmbeds.fulfilled.byId;
